import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "file"]

  connect() {
    this.change()
  }

  change() {
    if (!this.hasSelectTarget || !this.hasFileTarget) return

    this.fileTarget.accept = this.selectTarget.value === "pdf"
      ? this.selectTarget.dataset.pdfAccept
      : this.selectTarget.dataset.epubAccept
    this.fileTarget.value = ""
  }
}
